module.exports = __webpack_public_path__ + "img/calendar.a6dcbef4.svg";